/* Mana Rush review compatibility cleanup — v104 performance pass. */
(function () {
  'use strict';

  var pairs = [
    ['SuddenRush Guarana Shots', 'Mana Rush Guarana'], ['Suddenrush Guarana Shots', 'Mana Rush Guarana'], ['Sudden Rush Guarana Shots', 'Mana Rush Guarana'],
    ['SuddenRush Strong Guarana', 'Mana Rush Guarana'], ['SuddenRush Medium Guarana', 'Mana Rush Guarana'], ['SuddenRush Guarana', 'Mana Rush Guarana'],
    ['Sudden Rush Guarana', 'Mana Rush Guarana'], ['Suddenrush Guarana', 'Mana Rush Guarana'], ['SuddenRush', 'Mana Rush'], ['Sudden Rush', 'Mana Rush']
  ];
  var legacyRe = /(sudden\s*rush|suddenrush|energy\s*shot|guarana\s*shot|strong guarana|clearance)/i;

  function hideCard(el) {
    for (var cur = el, depth = 0; cur && depth < 8; cur = cur.parentElement, depth++) {
      var cls = (cur.className || '').toString();
      if (/jdgm|judge/i.test(cls) && /rev|review|carousel|item|card/i.test(cls)) {
        cur.style.display = 'none';
        return;
      }
    }
  }

  function cleanTextNode(node) {
    var original = node.nodeValue || '';
    if (!original) return;
    if (legacyRe.test(original)) hideCard(node.parentElement);
    var updated = original;
    for (var i = 0; i < pairs.length; i++) updated = updated.split(pairs[i][0]).join(pairs[i][1]);
    if (updated !== original) node.nodeValue = updated;
  }

  function normalizeReviewMedia() {
    var images = document.querySelectorAll('.jdgm-carousel-item__product-image[data-src], .jdgm-carousel-item__product-image');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      if (img.dataset && img.dataset.src && !img.getAttribute('src')) img.src = img.dataset.src;
      img.setAttribute('width', '96');
      img.removeAttribute('height');
      img.style.width = '96px';
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
      img.style.maxHeight = '96px';
      img.style.objectFit = 'contain';
      img.style.objectPosition = 'center';
    }
  }

  function run() {
    var roots = document.querySelectorAll('[class*="jdgm"], [class*="judgeme"]');
    for (var r = 0; r < roots.length; r++) {
      var walker = document.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT, null), node;
      while ((node = walker.nextNode())) cleanTextNode(node);
    }
    normalizeReviewMedia();
  }

  function lateRun() { window.setTimeout(run, 1200); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  if (document.readyState === 'complete') lateRun();
  else window.addEventListener('load', lateRun, { once: true });
  document.addEventListener('shopify:section:load', run);
})();
